// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./styleguide/fonts.scss
 ** module id = 1
 ** module chunks = 0
 **/